package com.vizio.redwolf.utils

data class M2MEnvironmentConfig(
    val environmentGroup: EnvironmentGroup,
    val serviceId: String,
    val serviceSecret: String,
    val apiKey: String
)